import { render } from "./login.vue?vue&type=template&id=36d70497&scoped=true&lang=pug"
import script from "./login.vue?vue&type=script&setup=true&lang=js"
export * from "./login.vue?vue&type=script&setup=true&lang=js"

import "./login.vue?vue&type=style&index=0&id=36d70497&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-36d70497"

export default script